// extracted by mini-css-extract-plugin
export var active = "_9b-7";
export var container = "_9b-0";
export var evenWidth = "_9b-4";
export var large = "_9b-5";
export var outlet = "_9b-8";
export var slide = "_9b-2";
export var small = "_9b-6";
export var tab = "_9b-3";
export var tabs = "_9b-1";